export const stringToAsciiCode = (ss: string) =>
  ss
    ?.split('')
    ?.map((s) => (s ? s?.charCodeAt(0) : ''))
    ?.join('');

